import { render, staticRenderFns } from "./NonCompliantProductFormComponent.vue?vue&type=template&id=345e2511"
import script from "./NonCompliantProductFormComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports